var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirclePlusBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.594,
    height: 30.594,
    viewBox: "0 0 30.594 30.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle-plus",
    d: "M0,15.3a15.3,15.3,0,1,1,15.3,15.3A15.3,15.3,0,0,1,0,15.3ZM15.3,21.99a1.431,1.431,0,0,0,1.434-1.434V16.731h3.824a1.434,1.434,0,1,0,0-2.868H16.731V10.039a1.434,1.434,0,1,0-2.868,0v3.824H10.039a1.434,1.434,0,1,0,0,2.868h3.824v3.824A1.431,1.431,0,0,0,15.3,21.99Z",
    fill: "#00AEEF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlusBlue);
export default __webpack_public_path__ + "static/media/circle-plus-blue.46488fad734f03931f6d834cdffa6bc2.svg";
export { ForwardRef as ReactComponent };